import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import Modal from 'react-overlays/lib/Modal';

import { translate } from 'react-i18next';

const modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0, bottom: 0, left: 0, right: 0
};

const backdropStyle = {
  position: 'fixed',
  top: 0, bottom: 0, left: 0, right: 0,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5
};

const dialogStyle = function() {
  // we use some psuedo random coords so nested modals
  // don't sit right on top of each other.

  return {
    position: 'absolute',
    width: 400,
    top: top + '%', left: left + '%',
    transform: `translate(-50%, -50%)`,
    border: '1px solid #e5e5e5',
    backgroundColor: 'white',
    boxShadow: '0 5px 15px rgba(0,0,0,.5)',
    padding: 20
  };
};

var SquallSuggestionsModal = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },


  continuePrequal(){
    AvailabilityActions.closeSquallSuggestionsModal(this.state.store.toJS());
  },

  selectSuggestion(i) {
    AvailabilityActions.selectSquallSuggestion(i);
  },

  backToStepOne() {
    AvailabilityActions.backToStepOne();
  },

    render() {
      const { t } = this.props;

      var store = this.state.store;

      if(Object.keys(store.get('lastPrequal').toJS()).length == 0) {
        return false;
      }

      var key = store.getIn(['lastPrequal', 'response', 'reason']);
      var suggestions = store.get('qual_suggestions').toJS();
      var selectSuggestion = this.selectSuggestion;
      var squallSuggestionSelected = store.get('squallSuggestionSelected');

    var address = {
      address: store.getIn(['lastPrequal', 'request', 'streetAddress']),
      unit: store.getIn(['lastPrequal', 'request', 'secondary']),
      city: store.getIn(['lastPrequal', 'request', 'city']),
      state: store.getIn(['lastPrequal', 'request', 'state']),
      zip: store.getIn(['lastPrequal', 'request', 'zip']),
      serviceType: store.getIn(['input_address', 'serviceType'])
    }

    if(address.unit) {
      address.address = address.address + ' ' + address.unit;
    }
    delete address.unit;

    return (
      <div>
        <Modal
          aria-labelledby='modal-label'
          style={modalStyle}
          backdropStyle={backdropStyle}
          show={store.get('showSquallSuggestionsModal')}
          onHide={this.close}
        >
        <div className="modal show" tabIndex="-1" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">{t('common:'+key+'_title')}</h4>
              </div>
              <div className="modal-body">
                <p>
                  {t('common:'+key+'_p')}
                  <br /><span> or </span>
                  <a style={{cursor: 'pointer'}}
                    onClick={this.backToStepOne}
                  >
                    return to the address form
                  </a>
                </p>

                <div className="qualSuggestionsContainer" >
                  <div key="og" className={"radio"+(squallSuggestionSelected === null ? ' active' : '')}>
                    <label onClick={function() { return selectSuggestion(null);}}>
                      <input type="radio" name="qualSuggestion" className="radio-inline" />
                      <i className={"fa fa-lg"+(squallSuggestionSelected === null ? " fa-check-square" : " fa-square-o")}></i>
                      <address>
                        Continue using my original address:
                        <br />
                        <span>{address.address}</span>
                        <br />
                        <span>{address.city} {address.state} {address.zip}</span>
                      </address>
                    </label>
                  </div>
                  {suggestions.map( (s, i) => (
                    <div key={i} className={'radio'+(i == squallSuggestionSelected ? ' active' : '')}>
                      <label onClick={function() {return selectSuggestion(i);}}>
                        <input type="radio" name="qualSuggestion" className="radio-inline" />
                      <i className={"fa fa-lg"+(squallSuggestionSelected === i ? " fa-check-square" : " fa-square-o")}></i>
                        <address>
                        <span>{[s.SrvcAddrHousNbr, 
                          s.SrvcAddrHousNbrSufx, 
                          s.SrvcAddrStDrctl, 
                          s.SrvcAddrStName, 
                          s.SrvcAddrStThoroughfare, 
                          s.LocationDesignator1, 
                          s.LocationValue1, 
                          s.LocationDesignator2, 
                          s.LocationValue2
                          ].map((str) => (str ? str.charAt(0).toUpperCase()+str.slice(1).toLowerCase() : '')).join(' ')}</span>
                        <br />
                        <span>{[
                            (s.human_city ? s.human_city : s.SrvcAddrCity.charAt(0).toUpperCase()+s.SrvcAddrCity.slice(1).toLowerCase()), 
                            s.SrvcAddrState, 
                            s.SrvcAddrZipCd
                          ].join(' ')}</span>
                        </address>
                      </label>
                    </div>
                  ))}
                
                </div>

              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-default btn-block" onClick={this.continuePrequal}>{t('common:continue')}</button>
              </div>
            </div>
          </div>
        </div>
        </Modal>
      </div>
    );
  }
});

export default  translate('common', { wait: true })(SquallSuggestionsModal);